<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createSource.show()"
          v-if="role_modules.some(item => item.value == 'candidate_source.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('candidate_source.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'candidate_source.view')"
        :useEdit="role_modules.some(item => item.value == 'candidate_source.edit')"
        :useDelete="role_modules.some(item => item.value == 'candidate_source.delete')"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'candidate_source') ? action : false"
        @openFormBar="openFormBar"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Source"
      ref="viewSource"
      size="md"
      :component="viewComponent"
      :parameters="{ sourceCandidateID, submitted }"
      v-if="role_modules.some(item => item.value == 'candidate_source.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Source"
      ref="createSource"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateSource"
      v-if="role_modules.some(item => item.value == 'candidate_source.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Source"
      ref="editSource"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{ sourceCandidateID, submitted }"
      @onYes="onUpdateSource"
      v-if="role_modules.some(item => item.value == 'candidate_source.edit')"
    />
    <Dialog
      centered
      autoload
      title="Delete Source"
      ref="deleteSource"
      size="md"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :component="deleteComponent"
      :parameters="{sourceCandidateID, submitted }"
      :module="'candidate_source'"
      @onYes="onDeleteSource"
      v-if="role_modules.some(item => item.value == 'candidate_source.delete')"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'
import DeleteComponent from '@components/dialogs/delete.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    createComponent () {
      return CreateComponent
    },
    viewComponent () {
      return ViewComponent
    },
    editComponent () {
      return EditComponent
    },
    deleteComponent () {
      return DeleteComponent
    },
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('candidate_source.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('candidate_source.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'candidate_source/pagination',
      sourceCandidateID: '',
      submitted: false,
      created: false,
      updated: false,
      deleted: false,
    }
  },
  methods: {
    openFormBar(id, editMode = false, deleteMode = false) {
      this.sourceCandidateID = id
      if (deleteMode) {
        this.$refs.deleteSource.show()
      } else if (!editMode) {
        this.$refs.viewSource.show()
      } else {
        this.$refs.editSource.show()
      }
    },
    
    onCreateSource(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('candidate_source/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData();
          this.$refs.createSource.hide();
          this.$bvToast.toast('Source successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onUpdateSource(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('candidate_source/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editSource.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Source successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },

    onDeleteSource(val) {
      this.deleted = true;
      let id = val && val.model && val.model._id ? val.model._id : 
               val && val.model && val.model.id ? val.model.id :
               val && val.id ? val.id : 
               val && val._id ? val._id : 
               this.sourceCandidateID;
      
      if (!id) {
        this.deleted = false;
        return;
      }

      return this.$store.dispatch('candidate_source/delete', { id })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.deleteSource.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Source successfully deleted!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.deleted = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      })
    }
  }
}
</script>